import { cn } from '@/platform/lib/utils';
import { MenuItem as HeadlessMenuItem } from '@headlessui/react';
import { Link } from '@inertiajs/react';
import Badge from '../Badge';

const MenuItem = ({
    as,
    href,
    icon: Icon,
    badge,
    className,
    children,
    ...props
}) => {
    const Component = as ?? (href ? Link : 'button');

    return (
        <HeadlessMenuItem>
            <Component
                href={href}
                className={cn(
                    'flex w-full items-center gap-x-4 px-4 py-2 text-left text-sm/6 text-gray-800 transition-colors',
                    'data-focus:bg-gray-900/5 data-focus:text-gray-900 data-focus:outline-hidden',
                    'data-disabled:opacity-50',
                    className
                )}
                {...props}
            >
                {Icon && <Icon className='size-4 shrink-0' />}
                {children}
                {badge && (
                    <Badge color={badge.color} className='ml-auto'>
                        {badge.content}
                    </Badge>
                )}
            </Component>
        </HeadlessMenuItem>
    );
};

export default MenuItem;
